import { apiClient } from '../client';
import type { components } from '@aaimplatform/institutional-types/platform-admin-api';

/**
 * GET /api/admin/dashboard, typed from the canonical contract
 * (schema-registry/platform-admin-api.openapi.yaml DashboardResponse). The
 * response carries the KPI strip only. The two integration-card aliases that
 * stood here aliased schemas deleted by name (ADR-038); no service measures a
 * per-integration status for them to carry.
 */
export type DashboardData = components['schemas']['DashboardResponse'];
export type DashboardKpi = components['schemas']['DashboardKpi'];
/**
 * The name api/services/index.ts re-exports. It aliases the generated schema
 * rather than restating it.
 */
export type PortfolioKPI = DashboardKpi;

export const dashboardApi = {
  get: async (): Promise<DashboardData> => {
    return apiClient.get<DashboardData>('/admin/dashboard');
  },
};
